import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Card, Button, ButtonGroup, Collapsible, Icon, Tooltip } from "@shopify/polaris"
import AppLinksForm from './AppLinksForm';
import { ChevronRightMinor, ChevronDownMinor, ChevronUpMinor, CategoriesMajorMonotone } from '@shopify/polaris-icons';

const propTypes = {
  link: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string.isRequired,
    sublinks: PropTypes.array,
    _destroy: PropTypes.bool, // for rails update flag for deletion
  }).isRequired,

  itemIndex: PropTypes.number.isRequired, // position of THIS Item according to parent list
  deepLevel: PropTypes.number.isRequired,
  parentAccessor: PropTypes.string.isRequired, // "app_links" || "app_links[0].sublinks"
  numberOfLinksOnParent: PropTypes.number.isRequired,

  handleLinkAction: PropTypes.func.isRequired,
  handleLinkRemove: PropTypes.func.isRequired,
  handleLinkPositionChange: PropTypes.func.isRequired,
}

const defaultProps = {

}

const AppLinkItem = (props) => {
  const { link } = props;
  const [open, setOpen] = useState(true);

  // const linkAccessorName = `${props.parentAccessor}.${props.itemIndex}`;
  const parentLinksAccessor = `${props.parentAccessor}.${props.itemIndex}.sublinks`; // For THIS item children
  const toggleSublinks = () => setOpen(!open)

  const onEditSublink = () => {
    props.handleLinkAction("UPDATE", props.parentAccessor, { ...link, index: props.itemIndex }, props.deepLevel ); // action, "accessor_for_this_link_parent_list", link values. added index to easy find on list
  }

  const onRemove = () => {
    props.handleLinkRemove(props.parentAccessor, { ...link, index: props.itemIndex } );
  }

  const handleMoveUp = () => { props.handleLinkPositionChange(props.parentAccessor, { ...link, index: props.itemIndex }, "UP" ) }
  const handleMoveDown = () => { props.handleLinkPositionChange(props.parentAccessor, { ...link, index: props.itemIndex }, "DOWN" ) }

  const canNestNewLevel = props.deepLevel <= 2;

  if(link._destroy)
    return null

  return (
    <div className="" style={{ backgroundColor: "white" }}>
        <div className="flex justifyBetween alignItemsCenter pv10 pr10">
          <div className='flex alignItemsCenter'>
            <Button plain onClick={ toggleSublinks }>
              <div className={`flex black alignItemsCenter ${!canNestNewLevel && 'pl10'}`}>
                { canNestNewLevel && <Icon color="#212b36" source={ open ? ChevronDownMinor : ChevronRightMinor } />  }
                { link.title }
              </div>
            </Button>
            { link.categorization_enabled &&
              <div className="ml10">
                <Tooltip content="Categorización automática habilitada">
                  <Icon source={CategoriesMajorMonotone} color="black" />
                </Tooltip>
              </div>
            }
          </div>
  
          <div>
            <ButtonGroup segmented>
              <Button onClick={ onEditSublink } >{ I18n.t("actions.edit") }</Button>
              <Button onClick={ onRemove }>{ I18n.t("actions.delete") }</Button>
              { props.numberOfLinksOnParent > 1 &&
                <>
                  { props.itemIndex >= 1 &&                                  <Button onClick={ handleMoveUp }><Icon source={ChevronUpMinor} /></Button> }
                  { props.itemIndex != (props.numberOfLinksOnParent - 1) &&  <Button onClick={ handleMoveDown }><Icon source={ChevronDownMinor} /></Button> }
                </>
              }
            </ButtonGroup>
          </div>
        </div>
        
        { canNestNewLevel &&
          <Collapsible
            open={open}
            transition={{duration: '500ms', timingFunction: 'ease-in-out'}}
            expandOnPrint
          >
            { <AppLinksForm 
                deepLevel={ props.deepLevel } 
                links={ link.sublinks || [] } 
                handleLinkAction={ props.handleLinkAction }
                handleLinkRemove={ props.handleLinkRemove }
                handleLinkPositionChange={ props.handleLinkPositionChange }
                parentListAccessor={ parentLinksAccessor }
                parentName={ link.title } /> 
            }
          </Collapsible>
          }
    </div>
  )
};

AppLinkItem.propTypes = propTypes;
AppLinkItem.defaultProps = defaultProps;

export default AppLinkItem;